// @ts-check
import React from 'react';
import { ErrorMessage, useField } from 'formik';
/* eslint-disable no-unused-vars */
import {
  ColorSwatchPicker,
  ColorSwatchPickerProps,
} from 'preferral-ui/components/ColorSwatchPicker';
import {
  HorizontalField,
  VerticalField,
} from 'preferral-ui/components/FieldStructure';
/* eslint-enable no-unused-vars */

/** @typedef {{
  name: string;
  id?: string;
  placeholder?: string;
  autoFocus?: boolean;
  className?: string;
  inputProps?: ColorSwatchPickerProps;
  disabled?: boolean;
}} ColorSwatchInputProps */

/** @type { React.FC<ColorSwatchInputProps> } */
export const ColorSwatchInput = (props) => {
  const {
    id,
    name,
    autoFocus = false,
    className = '',
    inputProps = {},
    disabled,
  } = props;

  const [field, meta, helpers] = useField(name);
  const { value, onBlur } = field;
  const { setValue } = helpers;

  return (
    <>
      <ColorSwatchPicker
        inputProps={{
          id: id || name,
          name,
          autoFocus,
          ...inputProps,
        }}
        className={
          meta && meta.touched && meta.error
            ? `border border-red-500 ${className}`
            : className
        }
        value={value}
        onChange={setValue}
        onBlur={onBlur}
        disabled={disabled}
      />
      <ErrorMessage
        component="p"
        name={name}
        className="mt-2 text-xs italic text-red-500"
      />
    </>
  );
};

/** @typedef {{
  label: string;
  indicateOptional?: boolean;
} & ColorSwatchInputProps } ColorSwatchFieldProps */

/** @type { React.FC<ColorSwatchFieldProps> } */
export const ColorSwatchField = (props) => {
  const { label, indicateOptional, ...rest } = props;

  return (
    <VerticalField
      id={`field--${rest.id || rest.name}`}
      htmlFor={rest.id || rest.name}
      label={label}
      indicateOptional={indicateOptional}
    >
      <ColorSwatchInput {...rest} />
    </VerticalField>
  );
};

/** @type { React.FC<ColorSwatchFieldProps> } */
export const HorizontalColorSwatchField = (props) => {
  const { label, indicateOptional, ...rest } = props;

  return (
    <HorizontalField
      id={`field--${rest.id || rest.name}`}
      htmlFor={rest.id || rest.name}
      label={label}
      indicateOptional={indicateOptional}
    >
      <ColorSwatchInput {...rest} />
    </HorizontalField>
  );
};
